import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';

const Header = (props) => {
    const { img } = props;

    return (
        <div className={styles.header}>
            <img src={img} alt="" />
        </div>
    );
};

Header.propTypes = {
    img: PropTypes.string
};

export default errorBoundary(Header);
